import { render, staticRenderFns } from "./NoticeModerationComment.vue?vue&type=template&id=6b79652e&scoped=true&"
import script from "./NoticeModerationComment.vue?vue&type=script&lang=js&"
export * from "./NoticeModerationComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b79652e",
  null
  
)

export default component.exports